import _ from 'lodash';

export const getQueryParamsUrl = searchQuery => {
  const checker = new URLSearchParams(searchQuery);
  let objParams = {};
  for(let pair of checker.entries()) {
    objParams = {
      ...objParams,
      [_.camelCase(pair[0])]: pair[1]
    }
  }
  return objParams
}